export default '/pricing/free-trial';
